import type { IPaymentConfigurationInput } from "lib";

export const defaultPaymentConfiguration: IPaymentConfigurationInput = {
    name: "",
    paymentMethods: [],
};
